import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapToEntries'
})
export class MapToEntriesPipe implements PipeTransform {

  public transform(map: Map<any, any>): [any, any][] {
    return Array.from(map.entries());
  }
}
